export const SelectsOptions = [
  { value: "dissolve", label: "Dissolve" },
  { value: "fadeInOut", label: "Fade in/out" },
  { value: "fragment", label: "Fragment" },
  { value: "turbulentDissolve", label: "Turbulent Dissolve" },
  // { value: "fadeIn", label: "Fade in" },
  // { value: "flash", label: "Flash" },
  // { value: "rubberBand", label: "Rubber Band" },
  // { value: "shakeX", label: "Shake X" },
  // { value: "shakeY", label: "Shake Y" },
  // { value: "wobble", label: "Wobble" },
  // { value: "jello", label: "Jello" },
  // { value: "heartBeat", label: "Heart Beat" },
];

export const viewSelectOptions = [
  { value: "grid", label: "Grid view" },
  { value: "list", label: "List view" },
];

export const templateSelectOptions = [
  { value: "1up", label: "1up" },
  { value: "n2Up", label: "n2Up" },
  { value: "n2Up-mirror-left", label: "n2Up - Mirror - flip left" },
  { value: "n2Up-mirror-right", label: "n2Up Mirror - flip right" },
  { value: "4up", label: "4up" },
  { value: "4up-warhol", label: "4up-warhol" },
  { value: "2next", label: "2next" },
  { value: "4next", label: "4next" },
];

export const filterSelectOptions = [
  { value: "", label: "None" },
  { value: "vintage-sepia", label: "Vintage Sepia" },
  { value: "cool-blue", label: "Cool Blue" },
  { value: "warm-orange", label: "Warm Orange" },
  { value: "neon-pink", label: "Neon Pink" },
  { value: "electric-cyan", label: "Electric Cyan" },
  { value: "golden-hour", label: "Golden Hour" },
  { value: "noir-bw", label: "Noir Black & White" },
  { value: "sunset-red", label: "Sunset Red" },
  { value: "forest-green", label: "Forest Green" },
  { value: "purple-haze", label: "Purple Haze" },
  { value: "distortion", label: "Distortion" },
  { value: "rainbow", label: "Rainbow" },
  { value: "double-vision", label: "Double Vision" },
  { value: "glitch", label: "Glitch" },
  { value: "kaleidoscope", label: "Kaleidoscope" },
  { value: "chromatic-aberration", label: "Chromatic Aberration" },
  { value: "motion-blur", label: "Motion Blur" },
  { value: "pixelate", label: "Pixelate" },
  { value: "vhs", label: "VHS" },
  { value: "neon-glow", label: "Neon Glow" },
];
